.container .search {
  /**background: var(--white);**/
  position: absolute;
  box-sizing: border-box;
  width: 100%;
  backdrop-filter: blur(200px);
  background-color: color-mix(in srgb, var(--white), transparent 12%);
  padding: 6px 8px;
  border-bottom: 2px solid var(--light-gray);
  z-index: 40;
}

.container .search::before {
  content: '';
  position: absolute;
  left: 0;
  top: 0;
  bottom: -2px;
  width: 4px;
  background: var(--purple);
}

.container .search .ui-input {
  border: none;
  border-radius: 0;
  background: transparent;
}

.container .search .ui-input:focus {
  outline-color: transparent;
}
